// lazy load add to calendar when the topmost container the button is present is in view
(() => {
  var buttonContainer = $(
    `.search-event-calendar-list:has(.calendar-add-button), 
    .glide:has(.calendar-add-button), 
    .section__event-details:has(.button__addToCalendar), 
    .columns-carousel:has(.js-add-to-calendar),
    .calendar-item:has(.calendar-add-button),
    .vendor-manage-events-container:has(.calendar-add-button)`
  );
  if (buttonContainer.length == 0) return;
  const desktopHeaderHeight = $("nav").height();
  // for containers that are in view on page load get the script as soon as possible
  lazyLoadAddToCalendar();
  function lazyLoadAddToCalendar() {
    var ContainerScrollDistance = buttonContainer.offset().top;
    var scrollDistance = $(window).scrollTop();
    var windowHeight = $(window).height();

    if (
      scrollDistance >=
      ContainerScrollDistance - windowHeight - desktopHeaderHeight
    ) {
      $.getScript("https://cdn.jsdelivr.net/npm/add-to-calendar-button@2");
      window.removeEventListener("scroll", lazyLoadAddToCalendar);
    }
  }

  window.addEventListener("scroll", lazyLoadAddToCalendar, { passive: true });
})();
